export const OPEN_XML_SPREADSHEET_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const FILE_EXTENSIONS_TYPE = {
  xlsx: OPEN_XML_SPREADSHEET_MIME_TYPE,
};

export const DATE_FORMAT = 'dd-MMM-yyyy';
